
import { TOKEN_STORAGE_KEY, USER_STORAGE_KEY } from './constants';
import { User } from './types';
import { setTokens } from '@/services/apiService';

export const saveAuthData = (token: string, user: User, refreshToken?: string): void => {
  // Use the centralized token management
  setTokens(token, refreshToken);

  // Save user data
  localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(user));
};

export const clearAuthData = (): void => {
  localStorage.removeItem(TOKEN_STORAGE_KEY);
  localStorage.removeItem('refresh_token');
  localStorage.removeItem(USER_STORAGE_KEY);
};

export const getStoredAuthData = (): { token: string | null; user: User | null } => {
  const storedToken = localStorage.getItem(TOKEN_STORAGE_KEY);
  const storedUser = localStorage.getItem(USER_STORAGE_KEY);

  let parsedUser = null;
  if (storedUser) {
    try {
      parsedUser = JSON.parse(storedUser);

      // Ensure userProfile and name exist and have the right structure
      if (!parsedUser.userProfile) {
        parsedUser.userProfile = {};
      }

      if (!parsedUser.userProfile.name) {
        parsedUser.userProfile.name = { firstName: '', lastName: '' };
      }

      // Ensure notification preferences exists
      if (!parsedUser.userProfile.notificationPreferences) {
        parsedUser.userProfile.notificationPreferences = {
          frequency: 'monthly',
          preferredTopics: [],
          notificationMethod: 'email',
          enabled: true
        };
      }
    } catch (e) {
      console.error('Error parsing stored user data:', e);
    }
  }

  return {
    token: storedToken,
    user: parsedUser
  };
};
